import { Menu, X } from 'lucide-react';
import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

import Logo from '@/assets/smartcity/logo.svg';
import Button from '@/shared/components/ui/Button';
import { URLS } from '@/shared/config/urls';

const APK_DOWNLOAD_URL = `${URLS.BACK_DSH}/app-version/download/latest`;

const HeaderIntro = () => {
  const location = useLocation();

  const [openMobile, setOpenMobile] = useState(false);
  const [isScroll, setIsScroll] = useState(false);

  const isHomePage = location.pathname === '/';

  const menu = [
    { name: 'Introduction', link: '#intro' },
    { name: 'Features', link: '#fitur' },
    { name: 'How it Works', link: '#howitworks' },
    { name: 'FAQ', link: '#faq' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setIsScroll(window.scrollY > 70);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);

    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      });
    }
    setOpenMobile(false);
  };

  return (
    <>
      <header
        className={`sticky top-0 left-0 right-0 z-50 transition-all ${
          isScroll ? 'bg-white/30 backdrop-blur-md shadow-sm' : ''
        }`}
      >
        <div className="grid h-[72px] grid-cols-[1fr_auto] items-center px-5 md:px-8 lg:grid-cols-[1fr_auto_1fr] lg:px-[100px]">
          {/* Logo */}
          <div className="flex items-center">
            <button type="button" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
              <img src={Logo} alt="logo" />
            </button>
          </div>

          {/* Desktop Menu */}
          <nav className="hidden items-center gap-10 lg:flex">
            {menu.map((item) => (
              <button
                type="button"
                key={item.name}
                onClick={() => scrollToSection(item.link.replace('#', ''))}
                className="h5 text-text-grey"
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Right */}
          <div className="hidden justify-end lg:flex">
            <Button
              label="Download App"
              variant="default"
              className="btn-fill-blue text-[20px] rounded-full hover:opacity-90"
              onClick={() => window.location.assign(APK_DOWNLOAD_URL)}
            />
          </div>

          {/* Hamburger */}
          <button
            type="button"
            className="justify-self-end lg:hidden"
            onClick={() => setOpenMobile(true)}
            aria-label="Open Menu"
          >
            <Menu size={26} />
          </button>
        </div>
      </header>

      {/* Mobile Drawer */}
      {openMobile && (
        <>
          <button
            type="button"
            className="fixed inset-0 z-40 bg-black/40"
            onClick={() => setOpenMobile(false)}
            aria-label="Close Menu"
          />

          <aside className="fixed right-0 top-0 z-50 flex h-screen w-[280px] flex-col bg-white shadow-xl">
            <div className="flex items-center justify-between border-b p-5">
              <img src={Logo} alt="logo" className="h-8" />

              <button type="button" onClick={() => setOpenMobile(false)} aria-label="Close Menu">
                <X size={24} />
              </button>
            </div>

            <nav className="flex flex-col gap-6 p-6">
              {menu.map((item) => (
                <button
                  type="button"
                  key={item.name}
                  onClick={() => scrollToSection(item.link.replace('#', ''))}
                  className="h5 text-text-grey text-left"
                >
                  {item.name}
                </button>
              ))}
              {/* {menu.map((item) => (
                <NavLink
                  key={item.name}
                  to={item.link}
                  onClick={() => setOpenMobile(false)}
                  className={({ isActive }) =>
                    isActive ? 'font-semibold text-text-green' : 'text-gray-700'
                  }
                >
                  {item.name}
                </NavLink>
              ))} */}
            </nav>

            <div className="mt-auto border-t p-6">
              <Button label="Unduh Aplikasi" variant="secondary" customButton="w-full" />
            </div>
          </aside>
        </>
      )}
    </>
  );
};

export default HeaderIntro;
